// src/components/PermissionGuard.js
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { hasPermission, hasAnyPermission } from '../utils/permissions';
import { Lock } from 'lucide-react';

export const PermissionGuard = ({ 
  children, 
  permission, 
  permissions, 
  requireAll = false,
  fallback = null,
  showMessage = false,
  messageText = "Permission insuffisante"
}) => {
  const { user } = useAuth();

  let hasAccess = false;

  // Vérification permission unique
  if (permission) {
    hasAccess = hasPermission(user, permission);
  } 
  // Vérification permissions multiples
  else if (permissions) {
    hasAccess = requireAll 
      ? permissions.every(p => hasPermission(user, p))
      : hasAnyPermission(user, permissions);
  }

  // Si pas d'accès et showMessage activé
  if (!hasAccess && showMessage) {
    return (
      <div className="inline-flex items-center gap-2 text-gray-400 text-sm">
        <Lock className="w-4 h-4" />
        <span>{messageText}</span>
      </div>
    );
  }

  // Retourner le contenu ou le fallback
  return hasAccess ? children : fallback;
};

export const usePermissionCheck = (permissionMap) => {
  const { user } = useAuth();
  
  const result = {};
  
  for (const [key, permission] of Object.entries(permissionMap)) {
    result[key] = hasPermission(user, permission);
  }
  
  return result;
};

export default PermissionGuard;